import { APIModel } from './api-model.model'

export class APIReport extends APIModel {
    reportId: number;
    categoryId: number;
    datasourceId: number;
    reportName: string;
    reportDescription: string;
    reportQuery: string;
    reportChartEnabled: number;
    chartTypeId: number;
    reportEnabled: number;
    userId: number;
    reportPrivateEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;

        reportId: number;
        categoryId: number;
        datasourceId: number;
        reportName: string;
        reportDescription: string;
        reportQuery: string;
        reportChartEnabled: number;
        chartTypeId: number;
        userId: number;
        reportEnabled: number;
        reportPrivateEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.reportId = params.reportId
        this.categoryId = params.categoryId
        this.datasourceId = params.datasourceId
        this.reportName = params.reportName
        this.reportDescription = params.reportDescription
        this.reportQuery = params.reportQuery
        this.reportChartEnabled = params.reportChartEnabled ? 1 : 0
        this.chartTypeId = params.chartTypeId
        this.reportEnabled = params.reportEnabled ? 1 : 0
        this.reportPrivateEnabled = params.reportPrivateEnabled ? 1 : 0
        this.userId = params.userId
    }
}
